import { CURRENT_USER_TOKEN } from '../lib/globals';
/**
 * Resolve `@me` tokens in a comma-separated user default value string,
 * replacing them with the given userId and deduplicating the result.
 */
export function resolveCurrentUserToken(cdf, userId) {
    return [
        ...new Set(cdf
            .split(',')
            .map((v) => v.trim() === CURRENT_USER_TOKEN ? userId : v.trim())
            .filter(Boolean)),
    ].join(',');
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlckhlbHBlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWIvdXNlckhlbHBlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsa0JBQWtCLEVBQUUsTUFBTSxlQUFlLENBQUM7QUFFbkQ7OztHQUdHO0FBQ0gsTUFBTSxVQUFVLHVCQUF1QixDQUNyQyxHQUFXLEVBQ1gsTUFBYztJQUVkLE9BQU87UUFDTCxHQUFHLElBQUksR0FBRyxDQUNSLEdBQUc7YUFDQSxLQUFLLENBQUMsR0FBRyxDQUFDO2FBQ1YsR0FBRyxDQUFDLENBQUMsQ0FBQyxFQUFFLEVBQUUsQ0FDVCxDQUFDLENBQUMsSUFBSSxFQUFFLEtBQUssa0JBQWtCLENBQUMsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLElBQUksRUFBRSxDQUNwRDthQUNBLE1BQU0sQ0FBQyxPQUFPLENBQUMsQ0FDbkI7S0FDRixDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQztBQUNkLENBQUMifQ==